import React from 'react';
import styled from 'styled-components';
import {reduxForm, FormSection} from 'redux-form'
import {
    FORM_ATTACHMENTS_SECTION, FORM_MESSAGES_SECTION, FORM_SUPPLEMENTARY_INFORMATION_SECTION,
    FORM_TICKET_SECTION, FORM_VEHICLE_DETAIL_SECTION,
} from '../../../../constants/formConstants';
import TicketStatusHistory from '../../../common/TicketStatusHistory';
import TicketSection from './sections/ticket/TicketSection';
import SupplementaryInformationOvalPlateSection
    from './sections/supplementaryInfo/SupplementaryInformationOvalPlateSection';
import MessagesSection from './sections/messagesSection/MessagesSection';
import VehicleDetailSection from './sections/vehicleDetail/VehicleDetailSection';
import RenderSyncErrors from '../../../common/RenderSyncErrors';
import {scrollContentWrapperToTop} from '../../../../utils/utils';
import AttachmentSection from './sections/attachments/AttachmentSection';
import SubmitButtons from './sections/SubmitButtons';
import formMessages from '../../../../intl/technicalDocumentations/formMessages';
import {techDocFieldLabelMapping} from '../../../../constants/techDocFieldLabelMapping';
import PropTypes from 'prop-types';

const StyledDiv = styled.div`
  border-radius: 10px;
`;

const OvalPlateOrderMasterForm = (props) => {
    const {form, userRights, readOnly, handleSubmit, reqFields, editMode} = props;

    return (
        <StyledDiv className="border border-dark p-4 bg-light">
            <RenderSyncErrors form={form} intlMessages={formMessages} mapping={techDocFieldLabelMapping}/>
            <FormSection name={FORM_TICKET_SECTION}>
                <TicketSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <FormSection name={FORM_VEHICLE_DETAIL_SECTION}>
                <VehicleDetailSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <FormSection name={FORM_SUPPLEMENTARY_INFORMATION_SECTION}>
                <SupplementaryInformationOvalPlateSection userRights={userRights} reqFields={reqFields}/>
            </FormSection>
            <FormSection name={FORM_MESSAGES_SECTION}>
                <MessagesSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <FormSection name={FORM_ATTACHMENTS_SECTION}>
                <AttachmentSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <TicketStatusHistory form={form}/>
            <SubmitButtons form={form} onSubmit={handleSubmit} onSubmitFail={scrollContentWrapperToTop}
                           userRights={userRights} readOnly={readOnly} editMode={editMode}/>
        </StyledDiv>
    )
}

OvalPlateOrderMasterForm.propTypes = {
    form: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func,
    readOnly: PropTypes.bool,
    userRights: PropTypes.object.isRequired,
    reqFields: PropTypes.array.isRequired,
};

export default reduxForm({})(OvalPlateOrderMasterForm);
